import { gql } from '@apollo/client';

export const CREATE_BAG = gql`
    mutation CreateBag($input: CreateBagInput!) {
        result: createBag(input: $input) {
            bags {
                id
                bagNumber
                bagType
                warehouseId
                sortingCode
                status
                createdAt
            }
            successCount
            errorMessage
        }
    }
`;

export interface CreateBagInput {
    bagType: number;
    sortingCode: string;
    warehouseId: string;
    copyNum: number;
    batchMode?: boolean;
    warehouseIdForBatch?: string;
    carrierCode?: number;
    stage3Letter?: string;
    stage4Digit?: string;
}

export interface CreateBagResult {
    bags: {
        id: string;
        bagNumber: string;
        bagType: number;
        warehouseId: string;
        sortingCode: string;
        status: number;
        createdAt: string;
    }[];
    successCount: number;
    errorMessage?: string;
}

export interface CreateBagResponse {
    result: CreateBagResult;
}